import { Phone, Mail, MapPin, ShieldCheck } from "lucide-react";

export default function Footer({ onBookClick }) {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative bg-[#0A0A0C] border-t border-white/10 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {/* CTA strip */}
        <div className="mb-16 p-8 md:p-12 rounded-3xl bg-gradient-to-br from-[#1A1A20] via-[#121216] to-[#0A0A0C] border border-[#D4AF37]/25 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <h3 className="text-2xl md:text-4xl font-semibold tracking-tighter text-white">
              Ready to upgrade your home?
            </h3>
            <p className="text-white/60 mt-2 text-base md:text-lg">
              Book a service in under 60 seconds.
            </p>
          </div>
          <button
            data-testid="footer-book-button"
            onClick={onBookClick}
            className="self-start md:self-auto inline-flex items-center gap-2 px-7 h-12 rounded-full bg-[#D4AF37] text-black font-semibold hover:bg-[#C5A017] transition-colors gold-glow"
          >
            Book Your Service
          </button>
        </div>

        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="grid place-items-center w-9 h-9 rounded-lg bg-[#D4AF37] text-black">
                <ShieldCheck size={18} strokeWidth={2.2} />
              </span>
              <span className="font-semibold tracking-tight text-white text-lg">
                All Service <span className="text-[#D4AF37]">Proz</span>
              </span>
            </div>
            <p className="text-white/55 text-sm leading-relaxed max-w-md">
              Atlanta's premium home installation specialists. Smart home, security, climate
              and home media — installed right the first time, every time.
            </p>
          </div>

          <div>
            <div className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold mb-4">
              Get in touch
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:4708080832"
                  data-testid="footer-phone"
                  className="flex items-center gap-2 text-white/75 hover:text-[#D4AF37]"
                >
                  <Phone size={15} />
                  <span>470-808-0832</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:allserviceproz@email.com"
                  data-testid="footer-email"
                  className="flex items-center gap-2 text-white/75 hover:text-[#D4AF37] break-all"
                >
                  <Mail size={15} />
                  <span>allserviceproz@email.com</span>
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/75">
                <MapPin size={15} className="mt-0.5" />
                <span>Metro Atlanta &amp; surrounding areas</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold mb-4">
              Hours
            </div>
            <ul className="space-y-2 text-sm text-white/60">
              <li className="flex justify-between"><span>Mon–Fri</span><span>8am–8pm</span></li>
              <li className="flex justify-between"><span>Saturday</span><span>9am–6pm</span></li>
              <li className="flex justify-between"><span>Sunday</span><span>By appt.</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} All Service Proz. Licensed &amp; Insured.</span>
          <span>Crafted for Metro Atlanta.</span>
        </div>
      </div>
    </footer>
  );
}
